import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { COLLABORATION_GENERATE_ACTION } from 'automation-ui-canvas/constants/Gates';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const CopilotCollaborationProvider = ({
  children
}) => {
  const isCollabEnabled = useIsUngated(COLLABORATION_GENERATE_ACTION);
  if (!isCollabEnabled) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: children
  });
};